import React from 'react'

const Privacy = () =>
  <div>
    <h1>Políticas de privacidad</h1>
    <p>lorem ipsum</p>
  </div>

export default Privacy
